
import {ACTIONS} from '../../actions/station.actions';

const initialState = {
  fetchInProgress: false,
  featchError: '',
  fetchUpdateInProgress: false,
  stations: {}
}

export default function stationsReducer(state = initialState, action) {

  switch(action.type) {
    case ACTIONS.StationsLoadingInProgress: return ({
      ...state,
      fetchInProgress: true,
      fetchError: '',
      stations: {}
    });

    case ACTIONS.StationsLoadingFailed: return ({
      ...state,
      fetchInProgress: false,
      fetchError: action.payload,
      stations: {}
    });

    case ACTIONS.StationsLoadingCompleted: return ({
      ...state,
      fetchInProgress: false,
      fetchError: '',
      stations: action.payload
    });

    default:
      return state;
  }

}


// WEBPACK FOOTER //
// ./src/reducers/stations/index.js